<template>
    <hts-drawer
        v-model="visible"
        color="main"
        size="large"
        :title="$t('labels.taskModule.detail')"
        @close="handleCloseClick">
        <div class="hts-vehicles-ignore-add-vehicle">
            <div class="hts-vehicles-ignore-add-vehicle__container-body">
                <hts-card :title="$t('labels.generalInformation')">
                    <hts-form-radio
                        v-model="dataTask.taskType"
                        class="col-span-2"
                        :label="$t('labels.type')"
                        :items="taskTypes"
                        type="list"
                        value-key="key"
                        label-key="label"
                        disabled />
                    <hts-form-input
                        v-model="dataTask.name"
                        :label="$t('labels.taskModule.name')"
                        :color="props.color"
                        readonly />
                    <hts-form-input
                        v-model="dataTask.description"
                        :label="$t('labels.description')"
                        :color="props.color"
                        name="description"
                        prop="description"
                        readonly />
                    <div v-if="dataTask.taskType === 'AFFECT_SHIPPING_TIME'">
                        <div class="flex">
                            <hts-form-checkbox
                                v-model="dataTask.canSplitWay"
                                :checked="!!dataTask.canSplitWay"
                                :items="[{ label: $t('labels.canSplitWay'), value: true }]"
                                readonly />
                            <hts-tooltip class="mt-1">
                                <div>
                                    <span class="font-bold">
                                        {{ $t('labels.canSplitWayInformation') }}
                                    </span>
                                </div>
                                <template #reference>
                                    <hi-information-circle-icon class="flex items-center text-green-500 w-6 h-6" />
                                </template>
                            </hts-tooltip>
                        </div>

                        <div class="flex">
                            <hts-form-checkbox
                                v-model="dataTask.requireContainerNumber"
                                :checked="!!dataTask.requireContainerNumber"
                                readonly
                                :items="[{ label: $t('labels.requireContainerNumber'), value: true }]" />
                        </div>

                        <div class="flex">
                            <hts-form-checkbox
                                v-model="dataTask.documentRequired"
                                readonly
                                :checked="!!dataTask.documentRequired"
                                :items="[{ label: $t('labels.documentRequired'), value: true }]" />
                        </div>

                        <div class="flex">
                            <hts-form-checkbox
                                v-model="dataTask.taskStartEndDurationRequired"
                                readonly
                                :checked="!!dataTask.taskStartEndDurationRequired"
                                :items="[{ label: $t('labels.taskStartEndDurationRequired'), value: true }]" />
                        </div>

                        <div class="flex">
                            <hts-form-checkbox
                                v-model="dataTask.allowCustomerViewDocument"
                                readonly
                                :checked="!!dataTask.allowCustomerViewDocument"
                                :items="[{ label: $t('labels.allowCustomerViewDocument'), value: true }]" />
                        </div>
                    </div>
                </hts-card>
                <hts-card
                    v-if="dataTask.taskType === 'AFFECT_SHIPPING_TIME'"
                    :title="$t('labels.earliestLatest')">
                    <div
                        v-for="(timeCondition, index) in dataTask.timeConditions"
                        :key="timeCondition">
                        <hr
                            v-if="index > 0"
                            class="my-4" >
                        <hts-form-input
                            v-model="timeCondition.name"
                            :label="$t('labels.earliestLatestName')"
                            :color="props.color"
                            readonly />
                        <hts-form-radio
                            v-model="timeCondition.type"
                            class="col-span-2"
                            :items="timeConditionTypes"
                            value-key="key"
                            label-key="label"
                            readonly />
                        <div class="grid grid-cols-2">
                            <div>
                                <hts-form-radio
                                    v-if="timeCondition.type === 'START'"
                                    v-model="timeCondition.timeType"
                                    class="ml-5"
                                    :items="timeConditionTimeTypes"
                                    value-key="key"
                                    label-key="label"
                                    readonly />
                            </div>
                            <div>
                                <hts-form-radio
                                    v-if="timeCondition.type === 'END'"
                                    v-model="timeCondition.timeType"
                                    class="ml-5"
                                    :items="timeConditionTimeTypes"
                                    value-key="key"
                                    label-key="label"
                                    readonly />
                            </div>
                        </div>
                    </div>
                </hts-card>
                <hts-card :title="$t('labels.completionTime')">
                    <div class="w-full overflow-x-auto">
                        <div class="min-w-[1024px]">
                            <hts-form-checkbox
                                v-model="dataTask.completionTimeCategories"
                                :items="transportationOptions()"
                                readonly />

                            <div class="flex flex-col gap-2">
                                <div class="grid-cols-4 grid gap-x-2">
                                    <p class="col-span-2 mb-2">
                                        {{ $t('labels.type') }}
                                    </p>
                                    <p :class="{ 'col-span-2': dataTask.taskType === 'NO_AFFECT_SHIPPING_TIME' }">
                                        {{ $t('labels.averageCompletionTime') }}
                                    </p>
                                    <p v-if="dataTask.taskType === 'AFFECT_SHIPPING_TIME'">
                                        {{ $t('labels.minimumCompletionTime') }}
                                    </p>
                                </div>
                                <template v-if="!dataTask.completionTimeCategories || dataTask.completionTimeCategories.includes(0)">
                                    <div
                                        v-for="completionTimeVehicle in dataTask.completionTimes?.vehicleCategory"
                                        :key="completionTimeVehicle"
                                        class="grid-cols-4 grid gap-x-5">
                                        <hts-form-input
                                            v-model="completionTimeVehicle.name"
                                            class="col-span-2"
                                            :color="color"
                                            readonly />
                                        <hts-form-input
                                            v-model="completionTimeVehicle.averageTime"
                                            :class="{ 'col-span-2': dataTask.taskType === 'NO_AFFECT_SHIPPING_TIME' }"
                                            type="number"
                                            :color="color"
                                            :number-decimal="1"
                                            readonly />
                                        <hts-form-input
                                            v-if="dataTask.taskType === 'AFFECT_SHIPPING_TIME'"
                                            v-model="completionTimeVehicle.minimumTime"
                                            type="number"
                                            :color="color"
                                            :number-decimal="1"
                                            readonly />
                                    </div>
                                </template>
                                <template v-if="!dataTask.completionTimeCategories || dataTask.completionTimeCategories.includes(1)">
                                    <div
                                        v-for="completionTimeCont in dataTask.completionTimes?.contCategory"
                                        :key="completionTimeCont"
                                        class="grid-cols-4 grid gap-x-5">
                                        <hts-form-input
                                            v-model="completionTimeCont.name"
                                            class="col-span-2"
                                            :color="color"
                                            readonly />
                                        <hts-form-input
                                            v-model="completionTimeCont.averageTime"
                                            :class="{ 'col-span-2': dataTask.taskType === 'NO_AFFECT_SHIPPING_TIME' }"
                                            type="number"
                                            :color="color"
                                            :number-decimal="1"
                                            readonly />
                                        <hts-form-input
                                            v-if="dataTask.taskType === 'AFFECT_SHIPPING_TIME'"
                                            v-model="completionTimeCont.minimumTime"
                                            type="number"
                                            :color="color"
                                            :number-decimal="1"
                                            readonly />
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </hts-card>
            </div>
        </div>

        <template #footer>
            <div />
        </template>
    </hts-drawer>
</template>
<script setup lang="ts">
import data from '../imports/data'
import { $api, $urlSystem } from '#imports'
import { initAddTask, initEditTask } from '~/pages/admincp/business/ignore/imports/form'
const { transportationOptions, contTypes, taskTypes, timeConditionTypes, timeConditionTimeTypes } = data()

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  }
})

const emits = defineEmits(['close', 'update:show', 'refreshTables'])

const visible = ref(false)
const dataTask: { [key: string]: any | null } = ref({ ...initEditTask })

const open = async (id: string) => {
  visible.value = true
  await getData(id)
}

const resetField = () => {
  dataTask.value = { ...initAddTask }
  dataTask.value.timeConditions = [
    {
      name: '',
      type: '',
      timeType: ''
    }
  ]
  dataTask.value.completionTimes = {
    vehicleCategory: [
      {
        id: '',
        name: '',
        averageTime: null,
        minimumTime: null
      }
    ],
    contCategory: [
      {
        id: '',
        name: '',
        averageTime: null,
        minimumTime: null
      }
    ]
  }
}

const getData = async (id: string) => {
  const api = $urlSystem.business.task.getById
  await $api(api, { uriParams: { ID: id } }).then((data: any) => {
    const resData: any = data?.data?.value
    if (resData?.success) {
      dataTask.value = resData.data

      dataTask.value.timeConditions = resData.data.timeConditions
        ? resData.data.timeConditions
        : [
          {
            name: '',
            type: '',
            timeType: ''
          }
        ]
      if (!dataTask.value.completionTimeCategories) {
        dataTask.value.completionTimeCategories = [0, 1]
      }
    }
  })
}

const setDataEstimatedCompletionTime = (completionTimes: any) => {
  if (!completionTimes) {
    dataTask.value.completionTimes = {
      vehicleCategory: [
        {
          id: '',
          name: '',
          averageTime: null,
          minimumTime: null
        }
      ],
      contCategory: [
        {
          id: '',
          name: '',
          averageTime: null,
          minimumTime: null
        }
      ]
    }
    return
  }

  const completionTimeCont: {
    id: string | number
    name: string
    averageTime: number | null
    minimumTime: number | null
  }[] = []

  let completionTimeVehicle: {
    id: string
    name: string
    averageTime: number | null
    minimumTime: number | null
  }[] = []

  const completionTimesValue = {
    contCategory: completionTimeCont,
    vehicleCategory: completionTimeVehicle
  }

  contTypes.forEach((item: { [key: string]: string | number }) => {
    if (completionTimes?.contCategory?.[item.value]) {
      completionTimeCont.push(completionTimes?.contCategory[item.value])
    } else {
      completionTimeCont.push({
        id: item.value as number,
        name: item.label as string,
        averageTime: null,
        minimumTime: null
      })
    }
  })
  completionTimesValue.contCategory = completionTimeCont

  if (!completionTimes.vehicleCategory) {
    Object.values(completionTimes.vehicleCategory).forEach((item: any) => {
      completionTimeVehicle.push(item)
    })
  } else {
    completionTimeVehicle = [
      {
        id: '',
        name: '',
        averageTime: null,
        minimumTime: null
      }
    ]
  }

  completionTimesValue.vehicleCategory = completionTimeVehicle

  dataTask.value.completionTimes = completionTimesValue
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-1'
})

const handleCloseClick = (e: any) => {
  visible.value = false
}

defineExpose({
  open
})
</script>
